import { TicketTypesQueries } from '@/graphql/queries/ticketTypes.queries'
import { TicketType, TicketTypeFilterParams } from '@/types/TicketType'

import { useGraphql } from '../useGraphql'

const useTicketTypes = () => {
  const filterParams: Partial<TicketTypeFilterParams> = {
    active: true,
    internal: true,
  }
  const ticketTypesQuery = useGraphql<{ ticketTypes: TicketType[] }>(
    TicketTypesQueries.QUERY_KEY,
    TicketTypesQueries.getTicketTypes(),
    { filter: filterParams },
  )
  return ticketTypesQuery
}

export default useTicketTypes
